<ion-content class="theme-{{userService.theme}}" [ngClass]="{'side-columns': isCallTeamDashboardEnabled}">
    <div class="content">
        <ion-header class="transparent">
            <app-header class="dark-mode"
                        [backRoute]="['/home']"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="true" [@enter]>
            </app-header>
        </ion-header>
        <div class="bg bg-inner-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform === 'mobile'}" [@enter]>
        </div>
        <app-manager-panel
            [managers]="managers"
            [managerId]="managerId"
            (managerChange)="selectFilter($event)"
        ></app-manager-panel>

        <div class="shadow-container">
          <div class="side-wrapper-left" *ngIf="isCallTeamDashboardEnabled">
            <div class="side-container my-journal"
                 *ngIf="isCallTeamDashboardEnabled"
                 (click)="goCallsTeamDashboard($event)">
              <div class="header primary-bg-color">{{'Team Performance' | translate}}</div>
              <div class="body">
                <app-inline-svg [cssClass]="'img'" [file]="'assets/img/checklist.svg'" ></app-inline-svg>
                <div>{{ "__TEAM_CLICK_TO_VIEW_MORE_INFO__" | translate }}</div>
              </div>
            </div>
          </div>
          <div class="side-wrapper-right" *ngIf="false">
          </div>

            <div [style.grid-template-columns]="getGridTemplateColumns()" class="table-header">
                <div style="text-align: left;">{{ "__TEAM_NAME__" | translate }}</div>
                <div *ngIf="isCoachingEnabled">{{ "__TEAM_GOALS_COACHING__" | translate }}</div>
                <div *ngIf="isReviewEnabled">{{ "__TEAM_PDR_1_TO_1__" | translate }}</div>
                <div *ngIf="isHyperboundEnabled">{{ "__TEAM_AI_ROLE_PLAY__" | translate }}</div>
                <div *ngIf="isMyTasksEnabled">{{ "__TEAM_USER_TASKS_COMPLETED__" | translate }}</div>
                <div *ngIf="isManagerTasksEnabled">{{ "__TEAM_MANAGER_TASKS_COMPLETED__" | translate }}</div>
            </div>
            <div class="inner-container">
                <ng-container *ngIf="teamList !== null">
                    <div [style.grid-template-columns]="getGridTemplateColumns()" class="shadow-element" *ngFor="let item of teamList" (click)="goDetails($event, item)">
                        <div style="text-align: left;">{{item.delegate.full_name}}</div>
                        <div *ngIf="isCoachingEnabled" (click)="goToCoachingJourney($event, item)">{{ "__TEAM_COACHING_JOURNEY__" | translate }}</div>
                        <img *ngIf="isReviewEnabled && item.review_tasks.total > 0" (click)="goToReviewReport($event, item)" class="shadow-element-btn margin-auto" src="assets/icon/folder.svg" alt="">
                        <img *ngIf="isReviewEnabled && !item.review_tasks.total" (click)="goToReviewReport($event, null)" class="shadow-element-btn margin-auto" src="assets/icon/folder-inactive.svg" alt="">
                        <app-pie *ngIf="isHyperboundEnabled" class="margin-auto link" [count]="item.aicoach_tasks.total" [activeCount]="item.aicoach_tasks.completed" [pendingCount]="item.aicoach_tasks.attempted"  [isAlwaysGreen]="true"  [isAlwaysChunked]="true" (click)="goToReviewCallsHistory($event, item)"></app-pie>
                        <app-pie *ngIf="isMyTasksEnabled" class="margin-auto" [count]="item.my_tasks.total" [activeCount]="item.my_tasks.completed"></app-pie>
                        <app-pie *ngIf="isManagerTasksEnabled" class="margin-auto" [count]="item.manager_tasks.total" [activeCount]="item.manager_tasks.completed"></app-pie>
                    </div>
                    <ng-container *ngIf="!teamList.length">
                        <div class="shadow-element" style="text-align: left;"><div style="font-size: 1.5rem; color: grey;">{{ "__TEAM_NO_ELEMENTS__" | translate }}</div></div>
                    </ng-container>
                </ng-container>
                <div *ngIf="teamList === null">
                    <app-team-list-skeleton></app-team-list-skeleton>
                    <app-team-list-skeleton></app-team-list-skeleton>
                    <app-team-list-skeleton></app-team-list-skeleton>
                </div>
            </div>
            <ion-footer *ngIf="menuVisible" slot="fixed" [@enterUp]>
                <app-footer [forAdmin]="(authService.getUserType() === 'manager')" [level]="'manager'"
                            [progress]="progress" currentPage="review-team"></app-footer>
            </ion-footer>
        </div>
    </div>
</ion-content>
